import createLucideIcon from '../createLucideIcon';

const Voicemail = createLucideIcon('Voicemail', [
  ['circle', { cx: '6', cy: '12', r: '4', key: '1ehtga' }],
  ['circle', { cx: '18', cy: '12', r: '4', key: '4vafl8' }],
  ['line', { x1: '6', x2: '18', y1: '16', y2: '16', key: 'pmt8us' }],
]);

export default Voicemail;
